import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Checkbox
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useState } from "react";
import { useEffectAsync } from "../reactHelper";

const LinkFieldAutoComplete = ({
  margin,
  variant,
  label,
  endpointAll,
  endpointLinked,
  baseId,
  keyBase,
  keyLink,
  keyGetter = (item) => item.id,
  titleGetter = (item) => item.name,
}) => {
  const [items, setItems] = useState();
  const [linked, setLinked] = useState();

  useEffectAsync(async () => {
    const response = await fetch(endpointAll);
    if (response.ok) {
      setItems(await response.json());
    }
  }, []);

  useEffectAsync(async () => {
    const response = await fetch(endpointLinked);
    if (response.ok) {
      const data = await response.json();
      setLinked(data.map((it) => it.id));
    }
  }, []);

  const createBody = (linkId) => {
    const body = {};
    body[keyBase] = baseId;
    body[keyLink] = linkId;
    return body;
  };

  const onChange = async (event, valueList, reason) => {
    const oldValue = linked;
    const newValue = valueList.map((item) => keyGetter(item));
    for (const added of newValue.filter((it) => !oldValue.includes(it))) {
      await fetch("/api/permissions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(createBody(added)),
      });
    }
    for (const removed of oldValue.filter((it) => !newValue.includes(it))) {
      await fetch("/api/permissions", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(createBody(removed)),
      });
    }
    setLinked(newValue);
  };
  const defaultVal = (linked && items) && items.filter((elem)=> linked.includes(elem.id));
  if (items && linked) {
    return (
      <FormControl margin={margin} variant={variant}>
        <InputLabel>{label}</InputLabel>
        <Autocomplete
          multiple
          limitTags={1}
          id="tags-outlined"
          options={items}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
              color='primary'
                // icon={icon}
                // checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {titleGetter(option)}
            </React.Fragment>
          )}
          getOptionLabel={(option) => titleGetter(option)}
          defaultValue={defaultVal}
          onChange={onChange}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{...params.InputProps, disableUnderline: true}}
              label={label}
              variant="standard"
            />
          )}
        />
      </FormControl>
    );
  } else {
    return null;
  }
};

export default LinkFieldAutoComplete;
